// src/utils/storieUtils.js

const FACTOR_A_DATA = {
  I: {
    5: 8.0,
    10: 16.4,
    15: 24.8,
    20: 33.2,
    25: 41.6,
    30: 50.0,
    35: 53.5,
    40: 56.8,
    45: 60.1,
    50: 63.4,
    55: 66.7,
    60: 70.0,
    65: 73.5,
    70: 76.8,
    75: 80.1,
    80: 83.4,
    85: 86.7,
    90: 90.0,
    95: 91.8,
    100: 93.4,
    105: 94.8,
    110: 96.7,
    115: 98.3,
    120: 100,
    125: 100,
    130: 100,
    135: 100,
    140: 100,
    145: 100,
    150: 100,
  },
  II: {
    5: 8.0,
    10: 16.4,
    15: 24.8,
    20: 33.2,
    25: 41.6,
    30: 50.0,
    35: 53.5,
    40: 56.8,
    45: 60.1,
    50: 63.4,
    55: 66.7,
    60: 70.0,
    65: 72.5,
    70: 75.0,
    75: 77.5,
    80: 80.0,
    85: 82.5,
    90: 85.0,
    95: 86.8,
    100: 88.4,
    105: 90.0,
    110: 91.7,
    115: 93.3,
    120: 95.0,
    125: 95.8,
    130: 96.6,
    135: 97.4,
    140: 98.2,
    145: 99.0,
    150: 100,
  },
  III: {
    5: 8.0,
    10: 14.4,
    15: 20.8,
    20: 27.2,
    25: 33.6,
    30: 40.0,
    35: 53.5,
    40: 46.8,
    45: 50.1,
    50: 53.4,
    55: 56.7,
    60: 60.0,
    65: 63.5,
    70: 66.8,
    75: 70.1,
    80: 73.4,
    85: 76.7,
    90: 80.0,
    95: 81.8,
    100: 83.6,
    105: 85.2,
    110: 86.8,
    115: 88.4,
    120: 90.0,
    125: 91.0,
    130: 91.8,
    135: 92.6,
    140: 93.4,
    145: 94.2,
    150: 95.0,
  },
  IV: {
    5: 6.8,
    10: 11.4,
    15: 16.2,
    20: 20.8,
    25: 25.4,
    30: 30.0,
    35: 32.0,
    40: 33.6,
    45: 35.2,
    50: 36.8,
    55: 38.4,
    60: 40.0,
    65: 42.0,
    70: 43.6,
    75: 45.2,
    80: 46.8,
    85: 48.4,
    90: 50.0,
    95: 51.8,
    100: 53.6,
    105: 55.2,
    110: 56.8,
    115: 58.4,
    120: 60.0,
    125: 62.0,
    130: 63.6,
    135: 65.2,
    140: 66.8,
    145: 68.4,
    150: 70.0,
  },
  V: {
    5: 8.0,
    10: 14.4,
    15: 20.8,
    20: 27.2,
    25: 33.6,
    30: 40.0,
    35: 43.5,
    40: 46.8,
    45: 50.1,
    50: 53.4,
    55: 56.7,
    60: 60.0,
    65: 62.0,
    70: 63.6,
    75: 65.2,
    80: 66.8,
    85: 68.4,
    90: 70.0,
    95: 71.8,
    100: 73.6,
    105: 75.2,
    110: 76.8,
    115: 78.4,
    120: 80.0,
    125: 82.0,
    130: 83.6,
    135: 85.2,
    140: 86.8,
    145: 88.4,
    150: 90.0,
  },
  VI: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 42.0,
    40: 43.6,
    45: 45.2,
    50: 46.8,
    55: 48.4,
    60: 50.0,
    65: 52.0,
    70: 53.6,
    75: 55.2,
    80: 56.8,
    85: 58.4,
    90: 60.0,
    95: 61.8,
    100: 63.6,
    105: 65.2,
    110: 66.8,
    115: 68.4,
    120: 70.0,
    125: 72.0,
    130: 73.6,
    135: 75.2,
    140: 76.8,
    145: 78.4,
    150: 80.0,
  },
  VII: {
    5: 5.0,
    10: 7.0,
    15: 11.0,
    20: 14.0,
    25: 17.0,
    30: 20.0,
    35: 22.0,
    40: 23.6,
    45: 25.2,
    50: 26.8,
    55: 28.4,
    60: 30.0,
    65: 32.0,
    70: 33.6,
    75: 35.2,
    80: 36.8,
    85: 38.4,
    90: 40.0,
    95: 43.5,
    100: 46.8,
    105: 50.1,
    110: 53.4,
    115: 56.7,
    120: 60.0,
    125: 63.5,
    130: 66.8,
    135: 70.1,
    140: 73.4,
    145: 76.7,
    150: 80.0,
  },
  VIII: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 43.5,
    40: 46.8,
    45: 50.1,
    50: 53.4,
    55: 56.7,
    60: 60.0,
    65: 62.0,
    70: 63.6,
    75: 65.2,
    80: 66.8,
    85: 68.4,
    90: 70.0,
    95: 71.8,
    100: 73.6,
    105: 75.2,
    110: 76.8,
    115: 78.4,
    120: 80.0,
    125: 82.0,
    130: 83.6,
    135: 85.2,
    140: 86.8,
    145: 88.4,
    150: 90.0,
  },
  IX: {
    5: 8.0,
    10: 16.4,
    15: 24.8,
    20: 33.2,
    25: 41.6,
    30: 50.0,
    35: 53.5,
    40: 56.8,
    45: 60.1,
    50: 63.4,
    55: 66.7,
    60: 70.0,
    65: 73.5,
    70: 76.8,
    75: 80.1,
    80: 83.4,
    85: 86.7,
    90: 90.0,
    95: 91.8,
    100: 93.4,
    105: 94.8,
    110: 96.7,
    115: 98.3,
    120: 100,
    125: 100,
    130: 100,
    135: 100,
    140: 100,
    145: 100,
    150: 100,
  },
  X: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 43.5,
    40: 46.8,
    45: 50.1,
    50: 53.4,
    55: 56.7,
    60: 60.0,
    65: 62.0,
    70: 63.6,
    75: 65.2,
    80: 66.8,
    85: 68.4,
    90: 70.0,
    95: 71.8,
    100: 73.6,
    105: 75.2,
    110: 76.8,
    115: 78.4,
    120: 80.0,
    125: 82.0,
    130: 83.6,
    135: 85.2,
    140: 86.8,
    145: 88.4,
    150: 90.0,
  },
  XI: {
    5: 8.0,
    10: 16.4,
    15: 24.8,
    20: 33.2,
    25: 41.6,
    30: 50.0,
    35: 53.5,
    40: 56.8,
    45: 60.1,
    50: 63.4,
    55: 66.7,
    60: 70.0,
    65: 73.5,
    70: 76.8,
    75: 80.1,
    80: 83.4,
    85: 86.7,
    90: 90.0,
    95: 91.8,
    100: 93.4,
    105: 94.8,
    110: 96.7,
    115: 98.3,
    120: 100,
    125: 100,
    130: 100,
    135: 100,
    140: 100,
    145: 100,
    150: 100,
  },
  XII: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 43.5,
    40: 46.8,
    45: 50.1,
    50: 53.4,
    55: 56.7,
    60: 60.0,
    65: 62.0,
    70: 63.6,
    75: 65.2,
    80: 66.8,
    85: 68.4,
    90: 70.0,
    95: 71.8,
    100: 73.6,
    105: 75.2,
    110: 76.8,
    115: 78.4,
    120: 80.0,
    125: 82.0,
    130: 83.6,
    135: 85.2,
    140: 86.8,
    145: 88.4,
    150: 90.0,
  },
  XIII: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 42.0,
    40: 43.6,
    45: 45.2,
    50: 46.8,
    55: 48.4,
    60: 50.0,
    65: 52.0,
    70: 53.6,
    75: 55.2,
    80: 56.8,
    85: 58.4,
    90: 60.0,
    95: 61.8,
    100: 63.6,
    105: 65.2,
    110: 66.8,
    115: 68.4,
    120: 70.0,
    125: 72.0,
    130: 73.6,
    135: 75.2,
    140: 76.8,
    145: 78.4,
    150: 80.0,
  },
  XIV: {
    5: 8.0,
    10: 16.4,
    15: 24.8,
    20: 33.2,
    25: 41.6,
    30: 50.0,
    35: 53.5,
    40: 56.8,
    45: 60.1,
    50: 63.4,
    55: 66.7,
    60: 70.0,
    65: 73.5,
    70: 76.8,
    75: 80.1,
    80: 83.4,
    85: 86.7,
    90: 90.0,
    95: 91.8,
    100: 93.4,
    105: 94.8,
    110: 96.7,
    115: 98.3,
    120: 100,
    125: 100,
    130: 100,
    135: 100,
    140: 100,
    145: 100,
    150: 100,
  },
  XV: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 43.5,
    40: 46.8,
    45: 50.1,
    50: 53.4,
    55: 56.7,
    60: 60.0,
    65: 62.0,
    70: 63.6,
    75: 65.2,
    80: 66.8,
    85: 68.4,
    90: 70.0,
    95: 71.8,
    100: 73.6,
    105: 75.2,
    110: 76.8,
    115: 78.4,
    120: 80.0,
    125: 82.0,
    130: 83.6,
    135: 85.2,
    140: 86.8,
    145: 88.4,
    150: 90.0,
  },
  XVI: {
    5: 8.0,
    10: 16.4,
    15: 24.8,
    20: 33.2,
    25: 41.6,
    30: 50.0,
    35: 53.5,
    40: 56.8,
    45: 60.1,
    50: 63.4,
    55: 66.7,
    60: 70.0,
    65: 73.5,
    70: 76.8,
    75: 80.1,
    80: 83.4,
    85: 86.7,
    90: 90.0,
    95: 91.8,
    100: 93.4,
    105: 94.8,
    110: 96.7,
    115: 98.3,
    120: 100,
    125: 100,
    130: 100,
    135: 100,
    140: 100,
    145: 100,
    150: 100,
  },
  XVII: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 42.0,
    40: 43.6,
    45: 45.2,
    50: 46.8,
    55: 48.4,
    60: 50.0,
    65: 52.0,
    70: 53.6,
    75: 55.2,
    80: 56.8,
    85: 58.4,
    90: 60.0,
    95: 61.8,
    100: 63.6,
    105: 65.2,
    110: 66.8,
    115: 68.4,
    120: 70.0,
    125: 72.0,
    130: 73.6,
    135: 75.2,
    140: 76.8,
    145: 78.4,
    150: 80.0,
  },
  XVIII: {
    5: 6.8,
    10: 13.6,
    15: 20.2,
    20: 26.8,
    25: 33.4,
    30: 40.0,
    35: 42.0,
    40: 43.6,
    45: 45.2,
    50: 46.8,
    55: 48.4,
    60: 50.0,
    65: 52.0,
    70: 53.6,
    75: 55.2,
    80: 56.8,
    85: 58.4,
    90: 60.0,
    95: 61.8,
    100: 63.6,
    105: 65.2,
    110: 66.8,
    115: 68.4,
    120: 70.0,
    125: 70.0,
    130: 70.0,
    135: 70.0,
    140: 70.0,
    145: 70.0,
    150: 70.0,
  },
};

export const getFactorA = (group = "I", depthVal) => {
  // depthVal doğrudan kullanıcının girdiği cm değeridir. kok_gel_derinlik kaldırıldı.
  const cm = parseFloat(depthVal);

  if (isNaN(cm)) return 100; // Geçersiz değerde varsayılan 100

  // Girilen cm değerini 5'in katlarına yuvarla ve 5 ile 150 arasında sınırla
  // (Çünkü Storie tablosu 5, 10, 15... 150 şeklinde gidiyor)
  const lookupCm = Math.max(5, Math.min(150, Math.round(cm / 5) * 5));

  const groupData = FACTOR_A_DATA[group] || FACTOR_A_DATA["I"];
  return groupData[lookupCm] || 100;
};

export const getFactorB = (textureRaw, stoneRaw, isCalcareous = false) => {
  // DÜZELTİLDİ: SİC, SİCL, SİL gibi büyük "İ" içeren kelimeleri
  // eşleştirebilmek için harf standardizasyonu getirildi.
  const tex = textureRaw
    ? textureRaw.split(" ")[0].trim().toUpperCase().replace(/İ/g, "I")
    : "";

  let score = 100;

  // Artık anahtarlar tümüyle büyük harf
  const textureScores = {
    L: 100,
    SIL: 100,
    VFSL: 100,
    CL: 90,
    SICL: 90,
    SCL: 90,
    C: 80,
    SIC: 80,
    SC: 80,
    FSL: 90,
    SL: 85,
    FLS: 75,
    LS: 65,
    S: 50,
  };

  if (textureScores[tex] !== undefined) score = textureScores[tex];

  if (isCalcareous && (tex === "CL" || tex === "SICL")) score = 95;

  let penalty = 0;
  if (stoneRaw) {
    if (stoneRaw.includes("T1")) penalty = 5;
    else if (stoneRaw.includes("T2")) penalty = 20;
    else if (stoneRaw.includes("T3")) penalty = 45;
  }

  return Math.max(0, score - penalty);
};

export const getFactorC = (slopeStr) => {
  const slopeMap = {
    "0-2": 100,
    "2-4": 97.5,
    "4-6": 95,
    "6-8": 90,
    "8-10": 85,
    "10-12": 80,
    "12-14": 77.5,
    "14-16": 75,
    "16-18": 72.5,
    "18-20": 70,
    "20-30": 60,
    "30-45": 60,
    "45+": 60,
  };
  if (!slopeStr) return 100;
  const s = String(slopeStr).replace("%", "").trim();
  if (slopeMap[s] !== undefined) return slopeMap[s];

  // "20-25", "30-35" gibi tabloda birebir olmayan araliklar ile tek sayi
  // ("10") girilmis kayitlar: ust siniri alip uygun banda yerlestiriyoruz.
  // Onceden bu degerler sessizce 100 donuyor, yani egim indeksi hic
  // dusurmuyordu.
  const sayilar = s.match(/\d+(?:[.,]\d+)?/g);
  if (!sayilar) return 100;
  const ust = parseFloat(sayilar[sayilar.length - 1].replace(",", "."));
  if (isNaN(ust)) return 100;

  const bantlar = [
    [2, 100],
    [4, 97.5],
    [6, 95],
    [8, 90],
    [10, 85],
    [12, 80],
    [14, 77.5],
    [16, 75],
    [18, 72.5],
    [20, 70],
  ];
  for (const [sinir, deger] of bantlar) if (ust <= sinir) return deger;
  return 60;
};

export const getFactorX = (
  drainage,
  selBasmasi, // YENİ EKLENDİ
  suErozyon,
  ruzgarAsinma,
  ruzgarYigilma,
  tuzluluk,
  alkalilik,
) => {
  let multiplier = 1.0;

  // 1. DRENAJ
  if (drainage) {
    if (drainage.includes("F3")) multiplier *= 0.25;
    else if (drainage.includes("F2")) multiplier *= 0.5;
    else if (drainage.includes("F1")) multiplier *= 0.65;
    else if (drainage.includes("K")) multiplier *= 0.85;
  }

  // 2. SEL BASMASI (Dokümana Göre Ortalama Değerler)
  if (selBasmasi) {
    if (selBasmasi.includes("F3"))
      multiplier *= 0.3; // 20-40 arası
    else if (selBasmasi.includes("F2"))
      multiplier *= 0.5; // 40-60 arası
    else if (selBasmasi.includes("F1")) multiplier *= 0.7; // 60-80 arası
  }

  // 3. SU EROZYONU
  const eroVal = suErozyon ? String(suErozyon).charAt(0) : "1";
  if (eroVal === "2") multiplier *= 0.9;
  else if (eroVal === "3") multiplier *= 0.8;
  else if (eroVal === "4") multiplier *= 0.5;

  // 4. RÜZGAR EROZYONU (Aşındırma ve Yığılma - En Kötüsü Baz Alınır)
  let asinmaCarpani = 1.0;
  if (ruzgarAsinma) {
    // R3 ve R6 aynı sayılır (3. Derece: %50-30 -> Ortalama 0.40)
    if (ruzgarAsinma.includes("R3") || ruzgarAsinma.includes("R6"))
      asinmaCarpani = 0.4;
    // R2 (2. Derece: %70-50 -> Ortalama 0.60)
    else if (ruzgarAsinma.includes("R2")) asinmaCarpani = 0.6;
    // R1 (1. Derece: %80-75 -> Ortalama 0.75)
    else if (ruzgarAsinma.includes("R1")) asinmaCarpani = 0.75;
  }

  let yigilmaCarpani = 1.0;
  if (ruzgarYigilma) {
    // Y3 ve Y6 aynı sayılır (3. Derece: %50-30 -> Ortalama 0.40)
    if (ruzgarYigilma.includes("Y3") || ruzgarYigilma.includes("Y6"))
      yigilmaCarpani = 0.4;
    // Y2 (2. Derece: %70-50 -> Ortalama 0.60)
    else if (ruzgarYigilma.includes("Y2")) yigilmaCarpani = 0.6;
    // Y1 (1. Derece: %80-75 -> Ortalama 0.75)
    else if (ruzgarYigilma.includes("Y1")) yigilmaCarpani = 0.75;
  }

  // İkisinden hangisinin çarpanı daha düşükse (puanı daha çok kırıyorsa) onu kullan
  multiplier *= Math.min(asinmaCarpani, yigilmaCarpani);

  // 5. TUZLULUK
  if (tuzluluk) {
    if (tuzluluk.includes("Hafif") || tuzluluk.includes("2")) multiplier *= 0.9;
    else if (
      tuzluluk.includes("Orta") ||
      tuzluluk.includes("3") ||
      tuzluluk.includes("4") ||
      tuzluluk.includes("5")
    )
      multiplier *= 0.7;
    else if (tuzluluk.includes("Çok") || tuzluluk.includes("6"))
      multiplier *= 0.15;
  }

  // 6. ALKALİLİK
  if (alkalilik) {
    if (alkalilik.includes("Orta") || alkalilik.includes("X2"))
      multiplier *= 0.85;
    else if (
      alkalilik.includes("Fazla") ||
      alkalilik.includes("X3") ||
      alkalilik.includes("X4")
    )
      multiplier *= 0.6;
  }

  return Math.round(multiplier * 100);
};

export const calculateStorieIndex = (data) => {
  const A = getFactorA(data.profilgrup, data.tesirli_derinlik);

  const B = getFactorB(
    data.horizons?.[0]?.tekstur,
    data.taslilik,
    data.horizons?.some((h) => h.kirec === "Kuvvetli"),
  );

  const C = getFactorC(data.egim_yuzde);

  // DİKKAT: data.sel_basmasi paramtresi eklendi
  const X = getFactorX(
    data.tabii_drenaj,
    data.sel_basmasi,
    data.su_erozyon_derecesi,
    data.ruzgar_asinma,
    data.ruzgar_yigilma,
    data.tuzluluk,
    data.alkalilik,
  );

  // Formül: (A * B * C * X) / 1.000.000 (Orijinal Storie formülü)
  const finalIndex = ((A * B * C * X) / 1000000).toFixed(2);

  return { factorA: A, factorB: B, factorC: C, factorX: X, finalIndex };
};
